module.exports = __webpack_public_path__ + "img/refresh_b.3036e43f.svg";